import "../App.css";
import React, { useEffect } from "react";
import { useLocation, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../views/home/home-page";
import routes from "../constants/routes";
import SignUpPage from "../views/auth/sign-up-page";
import SignInPage from "../views/auth/sign-in-page";
import Navbar from "../components/navbar/Navbar";
import MiniDrawer from "../components/sidebar/sidebar";
import { darkColors } from "../theme/colors";
import { useMediaQuery, useTheme } from "@mui/material";
import RaceDetails from "../views/race/race-details";
import { useProfileVisibility } from "../context/profile-visibility-context";
import UserProfilePage from "../views/profile/user-profile";
import CommunityPage from "../views/community/community";
import AccountPage from "../views/account/account-page";
import SecurityPage from "../views/account/security-page";
import PrivacyPage from "../views/account/privacy-page";
import BillingPage from "../views/account/billing-page";
import UserBetsPage from "../views/account/user-bets-page";
import SettingsPage from "../views/account/settings-page";
import LiveGamesPage from "../views/live-games/live-games-page";
import useFetchUserProfile from "../hooks/window-size/use-fetch-user-profile";
import NotFoundPage from "../views/404/404-page";
import ServerErrorPage from "../views/5xx/5xx-page";
import ConnectWalletPage from "../views/connect-wallet/connect-wallet";
import apiRoutes from "../api/routes";
import useApiRequest from "../api/api";
import { useUser } from "../context/user-context";
import WinningNotificationPage from "../views/winning-notification/winning-notification-page";

function Layout() {
  const location = useLocation();
  const theme = useTheme();
  const { makeApiCall } = useApiRequest();
  const { user, updateUser } = useUser();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const { showProfile } = useProfileVisibility();
  const storedUser = JSON.parse(localStorage.getItem("user"));

  useFetchUserProfile();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const noNavbarRoutes = [routes.register, routes.login, routes.connect_wallet];

  const noSideBarRoutes = [
    routes.account,
    routes.security,
    routes.privacy,
    routes.billing,
    routes.register,
    routes.login,
    routes.notFound,
    routes.serverError,
    routes.connect_wallet,
    routes.user_bets,
    routes.winning_notification,
  ];
  const showNavbarAndDrawer = !noNavbarRoutes.includes(location.pathname);

  const showSidebar = !noSideBarRoutes.includes(location.pathname);
  const TitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
      const titleMappings = {
        "/home": "Home - PlanetJ",
        "/live-games": "Live Games - PlanetJ",
      };

      document.title = titleMappings[location.pathname] || "PlanetJ";
    }, [location]);

    return null; // This component doesn't render anything
  };

  return (
    <div
      className="App"
      style={{
        display: "flex",
        flexDirection: showNavbarAndDrawer ? "row" : "column",
        minHeight: "100vh",
        overflow: showNavbarAndDrawer ? "hidden" : "auto",
      }}
    >
      {showNavbarAndDrawer && showSidebar && !showProfile && (
        <div
          style={{
            zIndex: 1,
          }}
        >
          <MiniDrawer />
        </div>
      )}

      <div
        className="App-content"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: showNavbarAndDrawer ? "hidden" : "auto",
          height: "100vh",
        }}
      >
        {showNavbarAndDrawer && (
          <div style={{ position: "relative", zIndex: 2 }}>
            <Navbar />
          </div>
        )}

        <div
          style={{
            flex: 1,
            overflow: showNavbarAndDrawer ? "hidden" : "auto",
            marginLeft: showSidebar ? (isMediumScreen ? "0px" : "270px") : "0",
            background: `linear-gradient(to bottom, ${darkColors.pagesBgTop}, ${darkColors.pagesBgBottom})`,
          }}
        >
          <TitleUpdater />
          <Routes>
            <Route path={routes.default} element={<HomePage />} />
            <Route path={routes.home} element={<HomePage />} />
            <Route path={routes.register} element={<SignUpPage />} />
            <Route path={routes.login} element={<SignInPage />} />
            <Route path={routes.race} element={<RaceDetails />} />
            <Route path={routes.profile} element={<UserProfilePage />} />
            <Route path={routes.community} element={<CommunityPage />} />
            <Route path={routes.communityArticle} element={<CommunityPage />} />
            <Route path={routes.account} element={<AccountPage />} />
            <Route path={routes.security} element={<SecurityPage />} />
            <Route path={routes.privacy} element={<PrivacyPage />} />
            <Route path={routes.billing} element={<BillingPage />} />
            <Route path={routes.user_bets} element={<UserBetsPage />} />
            <Route path={routes.live_games} element={<LiveGamesPage />} />
            <Route path={routes.notFound} element={<NotFoundPage />} />
            <Route path={routes.serverError} element={<ServerErrorPage />} />
            <Route
              path={routes.winning_notification}
              element={<WinningNotificationPage />}
            />
            <Route
              path={routes.connect_wallet}
              element={<ConnectWalletPage />}
            />
            <Route
              path="*"
              element={<Navigate to={routes.notFound} replace />}
            />

            <Route
              path="/settings"
              element={
                !isMediumScreen ? (
                  <Navigate to={routes.account} replace />
                ) : (
                  <SettingsPage />
                )
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Layout;
